import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const vipListState = {
  vipList: null,
  vipBalance: null,
  vipReport: null,
  vipDownline: null,
};

export const vipListSlice = createSlice({
  name: "vipList",
  initialState: vipListState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },

    vipListFetched: (state, action) => {
      state.listLoading = false;
      state.vipList = action.payload.data;
    },
    vipReportFetched: (state, action) => {
      state.listLoading = false;
      state.vipReport = action.payload.data;
    },
    vipDownlineFetched: (state, action) => {
      state.listLoading = false;
      state.vipDownline = action.payload.data;
    },
    vipBalanceManaged: (state, action) => {
      state.actionsLoading = false;
      state.vipBalance = action.payload.data;
    },
  },
});
